<template>
  <van-checkbox-group v-model="value" class="collect-form-item-checkbox" :disabled="readonly">
    <van-checkbox v-for="(option, index) in item.options" :key="index" :name="option.value" shape="square">
      <span class="collect-form-item-checkbox-option-label">{{ option.label }}</span>
      <input
        v-if="option.other && item.value && item.value.indexOf('other') >= 0"
        v-model="item.otherText"
        class="collect-form-item-option-other-input"
        maxlength="200"
        :disabled="readonly"
        @click.stop
      />
      <OptionImage :option="option"></OptionImage>
    </van-checkbox>
  </van-checkbox-group>
</template>

<script>
import OptionImage from "./OptionImage";

export default {
  components: { OptionImage },
  props: ["item", "readonly", "row"],
  data() {
    return {
      value: this.row
        ? this.row.value instanceof Array
          ? this.row.value
          : []
        : this.item.value instanceof Array
        ? this.item.value
        : [],
    };
  },
  watch: {
    value: function (val) {
      if (this.row) {
        this.$set(this.row, "value", val);
      } else {
        this.$set(this.item, "value", val);
      }
    },
  },
  created() {},
  methods: {},
};
</script>
<style scoped>
</style>